import { useState } from 'react';
import { Download } from 'lucide-react';
import { useAuthStore } from '@/stores/auth';
import { api } from '@/utils/api';

export function LeadExportButton({ filters }: { filters: Record<string, string> }) {
  const role = useAuthStore(s => s.user?.role?.name);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  if (role?.trim().toLowerCase() !== 'admin') return null;

  async function download() {
    if (busy) return;
    setBusy(true);
    setMessage('');
    try {
      const { skip: _skip, take: _take, ...query } = filters;
      const response = await api.get('/leads-list', { params: { ...query, format: 'xlsx' }, responseType: 'blob' });
      const name = /filename="?([^";]+)"?/.exec(response.headers['content-disposition'] ?? '')?.[1] ?? 'leads.xlsx';
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = name;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      const count = Number(response.headers['x-aura-export-rows']) || 0;
      setMessage(response.headers['x-aura-export-capped'] === '1'
        ? `Downloaded ${count} leads. The 10,000-row limit was reached; narrow the filters to download the rest.`
        : `Downloaded ${count} leads.`);
    } catch {
      setMessage('Could not download leads. Please try again.');
    } finally { setBusy(false); }
  }

  return <div className="flex flex-col gap-1">
    <button onClick={download} disabled={busy} className="flex items-center gap-2 rounded-lg border border-[var(--border-primary)] bg-[var(--bg-surface)] px-3 py-2 text-sm font-medium text-[var(--text-secondary)] disabled:opacity-50">
      <Download size={16} /> {busy ? 'Downloading…' : 'Download XLSX'}
    </button>
    {message && <span role="status" className="max-w-xs text-xs text-[var(--text-secondary)]">{message}</span>}
  </div>;
}
